import React from "react"
import I9ProgressItem from "./I9ProgressItem"
import I9Section2Dialog from "./I9-edit/section2/I9Section2Dialog"
import Section1Review from "./I9-edit/section1/Section1Review"
import Section2Review from "./I9-edit/section2/Section2Review"

import RaisedButton from "material-ui/RaisedButton"
import UserI9Store from "../../stores/UserI9Store"
import UserStore from "../../stores/UserStore"

const i9Actions = require("../../actions/I9Actions")
const moment = require("moment")

export default class I9UserProgress extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            user: UserStore.getCurrentUserDetail()
        }
        this.i9ChangeEvent = this.i9ChangeEvent.bind(this)
        this.userChangeEvent = this.userChangeEvent.bind(this)
        this.onSection1SignatureChange = this.onSection1SignatureChange.bind(this)
        this.onSection2SignatureChange = this.onSection2SignatureChange.bind(this)
        this.editI9Section2Click = this.editI9Section2Click.bind(this)
        this.openI9Pdf = this.openI9Pdf.bind(this)
        this.onCloseI9Section2Edit = this.onCloseI9Section2Edit.bind(this)
    }

    componentDidMount() {
        UserI9Store.on("change", this.i9ChangeEvent)
        UserStore.on("change", this.userChangeEvent)
        this.setupData()
    }

    componentWillUnmount() {
        UserI9Store.removeListener("change", this.i9ChangeEvent, false)
        UserStore.removeListener("change", this.userChangeEvent, false)
    }

    i9ChangeEvent() {
        const _this = this
        this.setState(
            {
                i9: UserI9Store.getI9()
            },
            () => {
                _this.setupData()
            }
        )
    }

    userChangeEvent() {
        const _this = this
        this.setState(
            {
                user: UserStore.getCurrentUserDetail()
            },
            () => {
                _this.setupData()
            }
        )
    }

    section1SignatureComplete() {
        if (this.state.i9) {
            if (this.state.i9.Employee_SignatureGraphicFileId && this.state.i9.Employee_SignatureGraphicFileId.length > 0) {
                return true
            }
        }
        return false
    }

    section2SignatureComplete() {
        if (this.state.i9) {
            if (this.state.i9.Certification_EmployerRepSignatureGraphicFileId && this.state.i9.Certification_EmployerRepSignatureGraphicFileId.length > 0) {
                return true
            }
        }
        return false
    }

    setupData() {
        if (!this.state.user) {
            return
        }

        const _this = this
        this.setState(
            {
                showProgress: this.state.user.I9Status ? this.state.user.I9Status.EnableI9Workflow : false
            },
            () => {
                if (_this.state.showProgress) {
                    _this.setState({
                        hireNotification: _this.state.user.I9Status.HireNotification,
                        section1Started: _this.state.user.I9Status.Section1Started,
                        section1Completed: _this.state.user.I9Status.Section1Complete,
                        section1SignatureComplete: _this.section1SignatureComplete(),
                        section2Started: _this.state.user.I9Status.Section1Complete,
                        section2Completed: _this.state.user.I9Status.Section2Complete,
                        section2SignatureComplete: _this.section2SignatureComplete()
                    })
                }
            }
        )
    }

    editI9Section2Click() {
        this.setState({
            openI9Section2Edit: true
        })
    }

    onCloseI9Section2Edit() {
        this.setState({
            openI9Section2Edit: false
        })
    }

    onSection1SignatureChange(imageData) {
        i9Actions.patchI9(this.state.i9.Id, {
            Employee_SignatureGraphicFile: imageData,
            Employee_SignatureDateTime: moment()
        })
    }

    onSection2SignatureChange(imageData) {
        i9Actions.patchI9(this.state.i9.Id, {
            Certification_EmployerRepSignatureGraphicFile: imageData,
            Certification_EmployerRepSignatureDateTime: moment()
        })
    }

    openI9Pdf() {
        window.open(UserI9Store.getI9Pdf())
    }

    render() {
        if (!this.state.showProgress) {
            return null
        } else {
            return (
                <div className="i9-user-progress I9UserProgress" style={{ textAlign: "center", width: "100%" }}>
                    <h2>I9 Information</h2>
                    <div>
                        <div style={{ padding: 20 }}>
                            <I9ProgressItem
                                active={true}
                                startedItem={this.state.hireNotification}
                                requireSignature={false}
                                completedItem={this.state.hireNotification}
                                icon="fa-commenting-o"
                                completedTitle="Hire Notice Sent via Text"
                            />
                            <I9ProgressItem
                                active={this.state.hireNotification}
                                startedItem={this.state.section1Started}
                                completedItem={this.state.section1Completed}
                                requireSignature={true}
                                signatureCompleted={this.state.section1SignatureComplete}
                                onSignatureChange={this.onSection1SignatureChange}
                                icon="fa-th-list"
                                startedTitle="Section 1 Started"
                                completedTitle="Section 1 Completed"
                                ReviewInfo={<Section1Review />}
                            />
                            <I9ProgressItem
                                active={this.state.section1Completed && this.state.section1SignatureComplete}
                                startedItem={this.state.section2Started}
                                completedItem={this.state.section2Completed}
                                requireSignature={true}
                                signatureCompleted={this.state.section2SignatureComplete}
                                onSignatureChange={this.onSection2SignatureChange}
                                onCompleteItemClick={this.editI9Section2Click}
                                icon="fa-check-circle"
                                startedTitle="Section 2 Started"
                                completedTitle="Section 2 Completed"
                                ReviewInfo={<Section2Review />}
                            />
                            {UserI9Store.getI9Pdf() &&
                                this.state.section2SignatureComplete &&
                                this.state.section2Completed && (
                                    <div
                                        style={{
                                            borderTop: "solid 1px #e7e7e7",
                                            paddingTop: 10
                                        }}
                                    >
                                        <RaisedButton label="View I9 PDF" secondary={false} icon={<i className="fa fa-file-pdf-o" />} onTouchTap={this.openI9Pdf} />
                                    </div>
                                )}
                        </div>
                    </div>
                    <I9Section2Dialog open={this.state.openI9Section2Edit} onClose={this.onCloseI9Section2Edit} user={this.state.user} />
                </div>
            )
        }
    }
}
